const AccessOptions = [
    'view_dashboard',
    'view_users',
    'edit_users',
    'delete_users',
    'view_groups',
    'edit_groups',
    'delete_groups',
    'view_levels',
    'edit_levels',
    'delete_levels',
    'view_events',
    'edit_events',
    'delete_events',
    'view_notifications',
    'edit_notifications',
    'send_notifications',
    'view_articles',
    'edit_articles',
    'delete_articles',
    'view_elections',
    'edit_elections',
    'delete_elections',
    'view_drive',
    'edit_drive',
    'delete_drive',
    'view_forms',
    'edit_forms',
    'delete_forms',
    'view_accounting',
    'edit_accounting',
    'delete_accounting',
    'view_pages',
    'edit_pages',
    'delete_pages',
    'view_analytics',
    'view_settings',
    'edit_settings',
    'manage_access_requests',
    'manage_resignation_requests'
];

export default AccessOptions;
